<template lang="pug">
div(
    data-testid="treeItem"
    class="flex"
    :class="level === 1 ? 'bg-gray-lighter' : 'bg-gray-light'"
)
    div(class="p-5 text-gray-darkest leading-tight")
        UniversalLink(
            :link="data.link.url"
            :data-level="level"
            class="block mb-5 font-bold whitespace-nowrap"
        ) {{ data.text }}

        div(class="flex")
            template(v-for="linkGroup in linkGroups")
                div(class="ml-5 pl-5 border-l-2 border-gray-light first:ml-0 first:pl-0 first:border-0")
                    template(v-for="item in linkGroup")
                        template(v-if="$storyblok.isVisible(item)")
                            //- Relative is required for triangle to work.
                            div(
                                v-bind="bindStoryblokBridgeData(item)"
                                class="relative w-48"
                            )
                                UniversalLink(
                                    :link="item.link.url"
                                    class="block mb-3 pr-5 text-sm"
                                    :class="{ 'triangle triangle-small': item.items}"
                                    @touchstart.native="showMenu(item._uid)"
                                    @mouseenter.native="showMenu(item._uid)"
                                    @mouseleave.native="clearTimer"
                                    :data-level="level"
                                ) {{item.text}}

    //- Recursively build further child panels
    template(v-if="data.items")
        template(v-for="item, index in data.items")
            template(v-if="item.items")
                template(v-if="$storyblok.isVisible(item)")
                    TreeItem(
                        v-show="activeMenuId===item._uid"
                        :data="item"
                        :level="level+1"
                    )
</template>

<script>
import UniversalLink from '@/components/universalLink.vue'
import { bindStoryblokBridgeData } from '../../../helpers'

export default {
    name: 'TreeItem',
    components: { UniversalLink },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
        level: {
            type: Number,
            default: 1,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activeMenuId: null,
        }
    },
    computed: {
        linkGroups() {
            if (!this.data.items) return []

            const groups = []
            const chunkSize = 14
            for (let i = 0; i < this.data.items.length; i += chunkSize) {
                const chunk = this.data.items.slice(i, i + chunkSize)
                groups.push(chunk)
            }

            return groups
        },
    },
    watch: {
        isActive(newVal) {
            if (!newVal) this.activeMenuId = null
        },
    },
    methods: {
        bindStoryblokBridgeData,
        clearTimer() {
            // If they mouseleave before the showMenu timer is done, clear it so we don't show it
            clearTimeout(this.navHoverTimer)
        },
        showMenu(menuIndex) {
            clearTimeout(this.navHoverTimer)

            this.navHoverTimer = setTimeout(() => {
                this.activeMenuId = menuIndex
            }, 175)
        },
    },
}
</script>
